import { render, staticRenderFns } from "./SplashPagesComponent.vue?vue&type=template&id=2b4fa103&scoped=true"
import script from "./SplashPagesComponent.vue?vue&type=script&lang=js"
export * from "./SplashPagesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4fa103",
  null
  
)

export default component.exports